import React from "react";
import { BlockEntrySection } from "./BlockEntries";
import {
  formatMetricValue,
  formatTargetLine,
  formatVsLastWeek,
  Sparkline,
  StatusChip,
} from "./metricDisplay";

// One KPI for the selected date: value, single-flag status chip, target
// subline, sparkline, and the shared entry section (including the
// required-response strip when the flag demands an explanation).
function MetricCardBlock(props) {
  const metric = props.metric;
  const config = props.block.config || {};

  if (!metric) {
    return null;
  }

  const isWeather = metric.format === "weather";
  const targetLine = formatTargetLine(metric.threshold, config.direction);

  return (
    <div className="group w-full bg-white border border-slate-200 rounded-xl px-4 py-3.5">
      <div className="flex items-center justify-between gap-2">
        {props.onTitleClick ? (
          <button
            type="button"
            onClick={props.onTitleClick}
            className="flex-1 min-w-0 text-left text-[11px] font-bold uppercase tracking-wider text-slate-400 truncate rounded focus-visible:ring-2 focus-visible:ring-violet-500"
          >
            {metric.label}
          </button>
        ) : (
          <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400 truncate">
            {metric.label}
          </p>
        )}
        {props.headerActions ? (
          props.headerActions
        ) : isWeather ? (
          metric.value?.text ? (
            <span className="text-[11px] font-bold text-slate-500 bg-slate-100 rounded-full px-2 py-0.5 whitespace-nowrap">
              {metric.value.text}
            </span>
          ) : null
        ) : (
          <StatusChip status={metric.threshold?.status} showNoTarget={false} />
        )}
      </div>

      {isWeather ? (
        <div className="flex items-center gap-1 mt-1">
          {metric.value?.icon && (
            <img
              src={metric.value.icon}
              alt={metric.value?.text || "Weather"}
              width={32}
            />
          )}
          <p className="text-2xl font-bold text-slate-900 tracking-tight">
            {metric.value ? `${metric.value.maxtemp}°F` : "--"}
          </p>
        </div>
      ) : (
        <p className="text-2xl font-bold text-slate-900 tracking-tight mt-1 tabular-nums">
          {formatMetricValue(metric.value, metric.format)}
        </p>
      )}

      {!isWeather && (targetLine || metric.vs_last_week !== null) && (
        <p className="text-[11px] text-slate-500 mt-0.5">
          {targetLine}
          {targetLine && metric.vs_last_week !== null && " · "}
          {metric.vs_last_week !== null &&
            `${formatVsLastWeek(metric.vs_last_week, metric.format)} vs last week`}
        </p>
      )}

      {!isWeather && (
        <Sparkline series={metric.series} format={metric.format} />
      )}

      {props.canAddEntries !== false && (
        <BlockEntrySection
          blockUuid={props.block.uuid}
          entries={props.entries}
          responseOutstanding={props.responseOutstanding}
          currentUser={props.currentUser}
          post_logbook_block_entry={props.post_logbook_block_entry}
          delete_logbook_block_entry={props.delete_logbook_block_entry}
        />
      )}
    </div>
  );
}

export default MetricCardBlock;
